module.exports = __webpack_public_path__ + "img/background.c30f43ed.jpg";